import React from "react";
import { ClearedStyleHref } from "@modules/Components";
import styled from "@emotion/styled";

const Href = styled(ClearedStyleHref)`
  width: 226px;
  height: 72px;
  border-radius: 36px;
  font-size: 16px;
  font-weight: bold;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 1150px) {
    margin: 0 auto;
  }
`;

const HrefColored = styled(Href)`
  font-size: 16px;
`;

const HeaderLine = styled.div`
  width: 36px;
  height: 3px;
  border-radius: 1.5px;
  margin: ${props => props.margin};
`;

const HeaderLineCenteredMobile = styled(HeaderLine)`
  @media (max-width: 1150px) {
    margin: 0 auto;
  }
`;

const MeetUsHeaderLineCenteredMobile = styled(HeaderLineCenteredMobile)`
  @media (max-width: 1150px) {
    margin-top: -56px;
  }
`;

const HowItWorksOffWhite = styled.div`
  background-color: rgba(251, 212, 152, 0.1);
  position: relative;

  @media (max-width: 1150px) {
    padding-bottom: 124px;
  }
`;

const HowItWorksMain = styled.div`
  border-radius: 0px 0px 460px 0px;
  background-blend-mode: overlay, normal;
  padding-top: 100px;
  padding-bottom: ${props => (props.paddingBottom ? "75px" : "100px")};

  @media (max-width: 1400px) {
    padding-top: 90px;
    padding-bottom: ${props => (props.paddingBottom ? "70px" : "90px")};
    border-radius: 0px 0px 370px 0px;
  }
  @media (max-width: 1300px) {
    padding-top: 85px;
    padding-bottom: ${props => (props.paddingBottom ? "66px" : "85px")};
  }
  @media (max-width: 767px) {
    border-radius: 0px 0px 250px 0px;
  }
  @media (max-width: 630px) {
    padding-bottom: ${props => (props.paddingBottom ? "63px" : "80px")};
  }
  @media (max-width: 530px) {
    border-radius: 0px 0px 100px 0px;
  }
`;

const HowItWorksHeader = styled.div`
  font-size: 48px;
  line-height: 1.5;
  text-align: center;
  color: #ffffff;
  padding-top: 33px;

  @media (max-width: 767px) {
    font-size: 32px;
  }
`;

const ProcessDiv = styled.div`
  display: grid;
  grid-template-columns: 1fr 50px 1fr 50px 1fr 50px 1fr;
  margin-top: 85px;

  @media (max-width: 1300px) {
    margin-top: 75px;
  }
  @media (max-width: 1150px) {
    grid-template-columns: 1fr 1fr;
    width: 80%;
    grid-row-gap: 50px;
    margin-top: 55px;
  }
  @media (max-width: 767px) {
    width: auto;
  }
  @media (max-width: 630px) {
    grid-template-columns: 1fr;
  }
`;

const ProcessItem = styled.div`
  font-size: 18px;
  font-weight: 500;
  line-height: 1.67;
  text-align: center;
  color: #ffffff;
  text-align: center;

  @media (max-width: 1400px) {
    font-size: 17px;
  }
  @media (max-width: 1300px) {
    font-size: 16px;
  }
  @media (max-width: 1150px) {
    font-size: 18px;
    line-height: 1.67;
    max-width: 278px;
    margin: 0 auto;
  }
  @media (max-width: 630px) {
    margin-top: 31px;
  }
`;

const ProcessText = styled.div`
  width: 241px;
  margin: 0 auto;
  margin-top: 50px;

  @media (max-width: 1400px) {
    width: 100%;
  }
  @media (max-width: 1150px) {
    margin-top: 40px;
  }
`;

const SquiglyImageDiv = styled.div`
  position: relative;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const SquiglyImage = styled.img`
  position: absolute;
  left: -50px;
  top: 50px;
  @media (max-width: 1400px) {
    left: -37px;
    top: 38px;
    width: 129px;
  }
`;

const SquiglyImageInverted = styled.img`
  position: absolute;
  left: -50px;
  top: 11px;
  -webkit-transform: rotate(180deg);
  -ms-transform: rotate(180deg);
  transform: rotate(173deg);

  @media (max-width: 1400px) {
    left: -37px;
    width: 129px;
  }
`;

const ProcessImageDiv = styled.div`
  width: 96px;
  height: 96px;
  box-shadow: 29px 29px 44px 0 rgba(31, 32, 33, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  margin: 0 auto;
`;

const TopLeftImage = styled.img`
  position: absolute;
  top: -64px;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const TopRightImage = styled.img`
  position: absolute;
  right: 0;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const BottomLeftImage = styled.img`
  position: absolute;
  max-height: 100%;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const BottomRightImage = styled.img`
  position: absolute;
  right: 0;

  @media (max-width: 1150px) {
    display: none;
  }
`;

const Salesman = styled.div`
  display: grid;
  width: 60%;
  grid-template-columns: 1fr 1fr;
  grid-gap: 160px;
  margin: 0 auto;
  // margin-top: 215px;

  @media (max-width: 1500px) {
    width: 75%;
    grid-gap: 100px;
  }
  @media (max-width: 1150px) {
    grid-gap: 57px;
  }
  @media (max-width: 915px) {
    grid-gap: 0px;
    width: 100%;
  }
  @media (max-width: 630px) {
    grid-template-columns: 1fr;
    // margin-top: 168px;
  }
`;

const PictureContainer = styled.div`
  text-align: center;
  width: 350px;
  margin: 0 auto;

  @media (max-width: 1150px) {
    width: 305px;
  }
  @media (max-width: 315px) {
    width: 100%;
  }
`;

const PictureInnerContainer = styled.div`
  width: 70%;
  margin: 0 auto;

  @media (max-width: 1150px) {
    width: auto;
  }
`;

const SalesmanImage = styled.img`
  width: 120px;
  height: 120px;
  margin-top: -65px;

  @media (max-width: 1150px) {
    margin-top: -56px;
  }
`;

const SalesmanStatement = styled.div`
  font-size: 16px;
  line-height: 1.88;
  color: rgba(31, 32, 33, 0.6);
  width: 262px;
  margin: 0 auto;
  margin-bottom: 52px;

  @media (max-width: 1150px) {
    width: 237px;
    margin-bottom: 41px;
  }
`;

const SalesmanName = styled.div`
  font-size: 18px;
  font-weight: bold;

  margin-top: 33px;
  margin-bottom: 28px;

  @media (max-width: 1150px) {
    margin-top: 37px;
  }
`;

const LinkContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 52px;

  @media (max-width: 1150px) {
    margin-bottom: 41px;
  }
`;

const MeetUs = styled.div`
  text-align: left;
  // padding-top: 39px;

  @media (max-width: 1150px) {
    text-align: center;
    padding-top: 0;
  }
  @media (max-width: 630px) {
    grid-row: 1/2;
    margin-bottom: 126px;
  }
`;

const MeetHeader = styled.div`
  font-size: 48px;
  line-height: 1.5;
  color: #1f2021;

  @media (max-width: 1500px) {
    font-size: 42px;
  }
  @media (max-width: 1150px) {
    font-size: 36px;
    line-height: 1.67;
  }
`;

const MeetP = styled.div`
  font-size: 18px;
  line-height: 2;
  color: #777984;
  width: 434px;
  margin-bottom: 15px;
`;

const SalesmanMainContainer = styled.div`
  position: relative;
  min-height: 664px;
  @media (max-width: 1150px) {
    min-height: auto;
  }
`;

const BulkMain = ({
  howItWorksArray,
  addButton,
  header,
  classFromParent,
  bottomLeftImage,
  bottomRightImage,
  meetPerson,
  personPicture,
  personStatement,
  personFirstP,
  personSecondP,
  addMeetPersonTalkButton,
  onButtonClick
}) => {
  return (
    <>
      <div className={classFromParent}>
        <HowItWorksOffWhite className="how-it-works-off-white">
          <TopLeftImage
            src="https://cdn.cardcash.com/website/ui/bulk/grey-left.svg"
            alt=""
          />
          <TopRightImage
            src="https://cdn.cardcash.com/website/ui/bulk/grey-right.svg"
            alt=""
          />
          <HowItWorksMain
            className="how-it-works-main"
            paddingBottom={addButton}
          >
            <HeaderLine margin={"0 auto"} className="header-line" />
            <HowItWorksHeader className="how-it-works-header">
              {header}
            </HowItWorksHeader>
            <ProcessDiv className="main-container-page-width">
              {howItWorksArray.map((item, index) => (
                <React.Fragment key={index}>
                  <ProcessItem>
                    <ProcessImageDiv className="process-image-div">
                      <img src={item.image} alt="" />
                    </ProcessImageDiv>

                    <ProcessText>{item.text}</ProcessText>
                  </ProcessItem>
                  {index === 0 || index === 2 ? (
                    <SquiglyImageDiv>
                      <SquiglyImage
                        src="https://cdn.cardcash.com/website/ui/bulk/line2.svg"
                        alt=""
                      />
                    </SquiglyImageDiv>
                  ) : index === 1 ? (
                    <SquiglyImageDiv>
                      <SquiglyImageInverted
                        src="https://cdn.cardcash.com/website/ui/bulk/line2.svg"
                        alt=""
                      />
                    </SquiglyImageDiv>
                  ) : null}
                </React.Fragment>
              ))}
            </ProcessDiv>
            {addButton && (
              <Href
                className={
                  "button-transition-hover-bgColor-color grey-link-button bulk-middle-button"
                }
                onClick={onButtonClick}
                type="button"
                as={"button"}
              >
                Let's talk
              </Href>
            )}
          </HowItWorksMain>
          <SalesmanMainContainer>
            <BottomLeftImage src={bottomLeftImage} alt="" />
            {bottomRightImage && (
              <BottomRightImage src={bottomRightImage} alt="" />
            )}
            <Salesman className="salesman-main-images-container">
              <PictureContainer className="picture-container">
                <PictureInnerContainer>
                  <SalesmanImage src={personPicture} alt="salesman image" />
                  <SalesmanName className="salesman-name-color">
                    {meetPerson}
                  </SalesmanName>
                  <SalesmanStatement className="salesman-statement-color">
                    {personStatement}
                  </SalesmanStatement>
                  {addMeetPersonTalkButton && (
                    <LinkContainer>
                      <HrefColored
                        className={
                          "button-transition-hover-bgColor-color bulk-href-colored"
                        }
                        onClick={onButtonClick}
                        type="button"
                        as={"button"}
                      >
                        Let's talk
                      </HrefColored>
                    </LinkContainer>
                  )}
                </PictureInnerContainer>
              </PictureContainer>

              <MeetUs className="meet-us">
                <MeetUsHeaderLineCenteredMobile className="header-line color-header-line" />
                <MeetHeader className="meet-header">
                  Meet {meetPerson.replace(/ .*/, "")}
                </MeetHeader>
                <MeetP className="meet-p">{personFirstP}</MeetP>
                <MeetP className="meet-p">{personSecondP}</MeetP>
              </MeetUs>
            </Salesman>
          </SalesmanMainContainer>
        </HowItWorksOffWhite>
      </div>
    </>
  );
};

export default BulkMain;
